import { useContext, useEffect } from 'react';
import { CreateStockTransfersContext, CreateStockTransfersValues } from '../contexts/CreateStockTransfersContext';
import { IconButton,
  Grid, 
  FormControl, 
  Select, 
  MenuItem, 
  TextField, 
  TableContainer, 
  Table, 
  TableHead, 
  TableRow, 
  TableCell, 
  TableBody, 
  SvgIcon, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { theme } from '../../../../../theme';
import { DynamicUomSelect } from '../../../../../components/shared/DymanicUomSelect';
import UpdateIcon from '@mui/icons-material/Update';
import Tooltip from '@mui/material/Tooltip';

export const CreateStockTransfersItemsTable = () => {
  const { itemsToCreate,
    itemPossibleUOMs,
    handleUomChange,
    handleQuantityChange,
    deleteButtonHandler,
    setItemsToCreate,
    t,
  } = useContext(CreateStockTransfersContext) as CreateStockTransfersValues;

  const bodyStyle = {
    borderBottom: '1px solid',
    borderBottomColor: theme.palette.custom.gray[200],
    px: '12px',
  };

  useEffect(() => {
    setItemsToCreate([]);
  }, []);

  return (
    <>
      {itemsToCreate.length > 0 && <Grid item
        xs={12}>
        <TableContainer component={'div'}>
          <Table
            size="small"
            aria-label="a table"
            sx={{
              borderBottom: '1px solid',
              borderTop: '1px solid',
              borderColor: theme.palette.custom.gray[200],
              width: '100%',
            }}
          >
            <TableHead sx={{ paddingTop: '10px', backgroundColor: theme.palette.custom.gray[200] }}>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }}
                  align="left">
                  {t('create_modal.item_number_header')}
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}
                  align="left">
                  {t('create_modal.item_description_header')}
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}
                  align="left">
                  {t('create_modal.item_quantity_header')}
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}
                  align="left">
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {itemsToCreate.map((row) => (
                <TableRow
                  key={row.id ?? -1}
                  sx={{ backgroundColor: theme.palette.custom.gray[50], '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell scope="row"
                    sx={bodyStyle}>
                    {row.itemNumber}
                  </TableCell>
                  <TableCell scope="row"
                    sx={bodyStyle}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      {row.newItemNumber && (
                        <Tooltip
                          title={t('create_modal.inTransition', { newItemNumber: row.newItemNumber })}
                          slotProps={{ tooltip: { sx: { maxWidth: 'none', whiteSpace: 'nowrap' } } }}
                        >
                          <UpdateIcon sx={{ fontSize: 18, mr: 1 , mb: 2  }} />
                        </Tooltip>
                      )}
                      {row.itemDescription}
                    </Box>
                    
                  </TableCell>
                  <TableCell scope="row"
                    sx={bodyStyle}>
                    <DynamicUomSelect
                      allowPrimaryUomDecimal={row.isAllowPartialUom}
                      seletedUom={row.uom ?? ''}
                      onUomChange={handleUomChange(row.id ?? -1)}
                      uoms={itemPossibleUOMs.find(x => x.id == row.id)?.uoms}
                      onQuantityChange={handleQuantityChange(row.id ?? -1)}
                      quantity={row.quantity}
                      error={row.quantityError}
                      helperText={row.errorDescription}
                      disabled={row.isDepositFeeItem}
                    />
                  </TableCell>
                  <TableCell scope="row"
                    sx={bodyStyle}>
                    <IconButton
                      size='small'
                      disabled={row.isDepositFeeItem}
                      onClick={(event) => deleteButtonHandler(event, row.id ?? -1)}
                    >
                      <SvgIcon color={row.isDepositFeeItem ? 'disabled' : 'error'}><CloseIcon></CloseIcon></SvgIcon>
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid >}
    </>
  );
};